import React, { useState } from 'react';

// Must match TreeNode.jsx's getNodeSize -- same pill dimensions, so empty
// slots line up with filled nodes in the layout.
const getNodeSize = (zoomLevel) => {
  switch (zoomLevel) {
    case 'zoomed_out':
      return { width: 44, height: 20, padding: 2, fontSize: 8 };
    case 'medium':
      return { width: 64, height: 28, padding: 3, fontSize: 10 };
    case 'close':
      return { width: 88, height: 36, padding: 4, fontSize: 12 };
    default:
      return { width: 110, height: 44, padding: 6, fontSize: 14 };
  }
};

const getZoomLevel = (zoom) => {
  if (zoom < 0.5) return 'zoomed_out';
  if (zoom < 1) return 'medium';
  if (zoom < 1.5) return 'close';
  return 'full';
};

export default function EmptyNode({ zoom, leg, level, onPlace, parentId, slotId }) {
  const [isHovered, setIsHovered] = useState(false);
  const zoomLevel = getZoomLevel(zoom);
  const size = getNodeSize(zoomLevel);
  const showButton = isHovered || zoomLevel === 'full';

  const nodeStyle = {
    width: `${size.width}px`,
    height: `${size.height}px`,
    minWidth: `${size.width}px`,
    minHeight: `${size.height}px`,
  };

  const handleClick = (e) => {
    e.stopPropagation();
    onPlace?.(parentId, leg, slotId);
  };

  return (
    <div
      data-tree-node
      className="absolute flex items-center justify-center rounded-lg border-2 border-dashed hover:opacity-80 transition-opacity cursor-pointer group"
      style={{
        ...nodeStyle,
        fontSize: `${size.fontSize}px`,
        padding: `${size.padding}px`,
        backgroundColor: 'transparent',
        borderColor: '#c9a961',
        color: '#c9a961',
      }}
      title={`Empty Slot - Leg ${leg}, Level ${level}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <div className="text-center text-[10px] font-medium flex flex-col items-center gap-1" style={{ color: '#c9a961' }}>
        {zoomLevel === 'full' ? `Leg ${leg}\nLevel ${level}\nEmpty` : 'Empty'}
        {showButton && zoomLevel !== 'zoomed_out' && (
          <button
            className="mt-1 px-2 py-0.5 text-[8px] rounded hover:opacity-90 transition-opacity whitespace-nowrap text-black"
            style={{ backgroundColor: '#c9a961' }}
            onClick={handleClick}
            title="Place user in this slot"
          >
            + Place
          </button>
        )}
      </div>
    </div>
  );
}
